import React from 'react';
import Header from './shared/Header';
import { useRandomLinkColors } from '../utils/useRandomLinkColors';
import { getRandomColor } from '../utils/colors';
const PrintsPage = () => {
  useRandomLinkColors();
  return <div className="min-h-screen bg-[#faf9f7] text-[#333333] font-serif" data-id="element-436" data-mp="1x9j9esv2k6nr">
      <Header data-id="element-437" data-mp="2295kavnfdate" />
      <main className="flex min-h-screen pt-24 px-6 pb-16" data-id="element-438" data-mp="228vw9dlxxdqc">
        {/* Mobile Layout */}
        <div className="md:hidden w-full max-w-2xl mx-auto" data-id="element-439" data-mp="1o9mpf4jmjvz1">
          <h1 className="text-4xl font-bold mb-8 leading-tight" data-id="element-440" data-mp="1oc8wl32ls9gq">
            Test Print 1
          </h1>

          <div className="text-base mb-8" data-id="element-441" data-mp="1ebq3rit29imo">
            <div className="mb-1" data-id="element-442" data-mp="1ecrqwlncpvkr">
              'Embarrassment of Riches (Downhills Park, London)'
            </div>
            <div className="mb-4" data-id="element-443" data-mp="1jbbe0pdoldep">2026</div>
            <div className="mb-4" data-id="element-444" data-mp="38ppxau5xk82t">Test Print Edition of 10 + 3 AP</div>

            <div className="mb-1" data-id="element-445" data-mp="38nmz3mumj8n0">Photographed on 4×5 sheet film.</div>
            <div className="mb-1" data-id="element-446" data-mp="3dnj67uymbg6s">
              Hand printed on Fomatone MG Classic fibre paper.
            </div>
            <div className="mb-4" data-id="element-447" data-mp="3r6lovc7odbnv">Unframed.</div>

            <div className="mb-1" data-id="element-448" data-mp="3m9v8sovveg2g">Paper Size: 10 × 8 in</div>
            <div className="mb-4" data-id="element-449" data-mp="3m7918p8zc0k8">Image Size: 9 9/16 × 7 9/16 in</div>

            <div className="italic mb-4" data-id="element-450" data-mp="4rk7m01j8k0i">
              All test prints are archival and signed. These editions are
              distinct from the future standard edition.
            </div>

            <div className="mb-4" data-id="element-451" data-mp="38an9zx3md9ys">
              Price: £222 (including free worldwide shipping).
            </div>

            <div className="mb-4" data-id="element-452" data-mp="33c271pwzgc6n">
              Each print is accompanied by a pressed four-leaf clover.
            </div>

            <div className="mb-8" data-id="element-453" data-mp="3h7xjpe0sgr1l">
              <a href="https://www.paypal.com/ncp/payment/BCG3E6QBPWA34" target="_blank" rel="noopener noreferrer" className="font-bold transition-colors duration-200" onMouseEnter={e => {
              e.currentTarget.style.color = getRandomColor();
            }} onMouseLeave={e => {
              e.currentTarget.style.color = '#333333';
            }} data-id="element-454" data-mp="3d8fahfiby4el">
                BUY HERE.
              </a>
            </div>

            <div data-id="element-455" data-mp="3v8zufewgi8vm">I am sending all my love and luck your way. ♡</div>
          </div>

          <img src="https://cdn.magicpatterns.com/uploads/a9sfC1HoE84uQrrcEBRkUS/1_Madeleine-Morlet_Embarassement-of-Riches-2026.jpg" alt="Embarrassment of Riches print on table" className="w-full h-auto mb-8" data-id="element-456" data-mp="36rxpetvl970" />
          <img src="https://cdn.magicpatterns.com/uploads/hZMoyxeWZwznAFYfBVphHG/2_Madeleine-Morlet_Embarassement-of-Riches-2026.jpg" alt="Embarrassment of Riches print" className="w-full h-auto" data-id="element-457" data-mp="3bmlbvn0qi8kw" />
        </div>

        {/* Desktop Layout */}
        <div className="hidden md:flex flex-row w-full max-w-6xl mx-auto gap-12" data-id="element-458" data-mp="2nxamf1ou40m2">
          <div className="w-full md:w-1/2 flex flex-col gap-8" data-id="element-459" data-mp="2nv69xvcvdta6">
            <img src="https://cdn.magicpatterns.com/uploads/a9sfC1HoE84uQrrcEBRkUS/1_Madeleine-Morlet_Embarassement-of-Riches-2026.jpg" alt="Embarrassment of Riches print on table" className="w-full h-auto" data-id="element-460" data-mp="2gdhtjnb155gv" />
            <img src="https://cdn.magicpatterns.com/uploads/hZMoyxeWZwznAFYfBVphHG/2_Madeleine-Morlet_Embarassement-of-Riches-2026.jpg" alt="Embarrassment of Riches print" className="w-full h-auto" data-id="element-461" data-mp="22ery0c3uzdum" />
          </div>

          <div className="w-full md:w-1/2 flex flex-col" data-id="element-462" data-mp="1smm775pcf2h0">
            <div className="max-w-2xl" data-id="element-463" data-mp="1nq5edy777zxl">
              <h1 className="text-4xl md:text-5xl font-bold mb-8 leading-tight" data-id="element-464" data-mp="1jnqynmyttgaj">
                Test Print 1
              </h1>

              <div className="text-base mb-8" data-id="element-465" data-mp="1eoxifms5nb6o">
                <div className="mb-1" data-id="element-466" data-mp="1eqqrf8q8q7hu">
                  'Embarrassment of Riches (Downhills Park, London)'
                </div>
                <div className="mb-4" data-id="element-467" data-mp="39s2mqtrdjy41">2026</div>
                <div className="mb-4" data-id="element-468" data-mp="39scdwko5obbb">Test Print Edition of 10 + 3 AP</div>

                <div className="mb-1" data-id="element-469" data-mp="3er6x3nq1c1vy">Photographed on 4×5 sheet film.</div>
                <div className="mb-1" data-id="element-470" data-mp="302an3l4f4esp">
                  Hand printed on Fomatone MG Classic fibre paper.
                </div>
                <div className="mb-4" data-id="element-471" data-mp="3502fshcw04xy">Unframed.</div>

                <div className="mb-1" data-id="element-472" data-mp="34yrf4qeqndb2">Paper Size: 10 × 8 in</div>
                <div className="mb-4" data-id="element-473" data-mp="2qzroxebkuqcs">Image Size: 9 9/16 × 7 9/16 in</div>

                <div className="italic mb-4" data-id="element-474" data-mp="2v3zetetruccl">
                  All test prints are archival and signed. These editions are
                  distinct from the future standard edition.
                </div>

                <div className="mb-4" data-id="element-475" data-mp="2m3b2qpnxum2c">
                  Price: £222 (including free worldwide shipping).
                </div>

                <div className="mb-4" data-id="element-476" data-mp="fcldpnmhhl7e">
                  Each print is accompanied by a pressed four-leaf clover.
                </div>

                <div data-id="element-477" data-mp="24snumqvb1rl7">
                  <a href="https://www.paypal.com/ncp/payment/BCG3E6QBPWA34" target="_blank" rel="noopener noreferrer" className="font-bold transition-colors duration-200" onMouseEnter={e => {
                  e.currentTarget.style.color = getRandomColor();
                }} onMouseLeave={e => {
                  e.currentTarget.style.color = '#333333';
                }} data-id="element-478" data-mp="24tyzku0hl5dw">
                    BUY HERE.
                  </a>
                </div>
              </div>
            </div>
            <div className="flex-1" data-id="element-479" data-mp="2xficdg0qmcuz"></div>
            <div className="text-base" data-id="element-480" data-mp="2shymfiuogbn7">
              I am sending all my love and luck your way. ♡
            </div>
          </div>
        </div>
      </main>
    </div>;
};
export default PrintsPage;